module.exports = __webpack_public_path__ + "static/img/banner-1.5d664614.png";